module.exports = __webpack_public_path__ + "img/add-reaction.7d017c8f.svg";